//include 8
jQuery(function () {

    var counter = 1;

    var privateFunctions = {
        getBoundingClientRect(el){
            return el[0].getBoundingClientRect();
        },  
        isElementPartiallyInViewport(el) {
            var rect = this.getBoundingClientRect(el);

            var topOutside = (rect.top < 0 && rect.bottom < 0) || (rect.top > $(window).height() && rect.bottom > $(window).height());
            var leftOutside = (rect.left < 0 && rect.right < 0) || (rect.left > $(window).width() && rect.right > $(window).width());

            return !topOutside && !leftOutside;
        },     
        isElementCompletelyInViewport(el) {
            var rect = this.getBoundingClientRect(el);
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= $(window).height() &&
                rect.right <= $(window).width()
            );
        },
        getHeaderHeight(){
            var header = $(".off-canvas-content .header-wrapper .header");
            if(header.length == 0)
                return 0;
            return header.height();
        },
        positionLogo($this) {
            var logoWrapper = $this.find('.loader-image-wrapper');
            if (logoWrapper.length == 0)
                return;
            if(this.isElementCompletelyInViewport(logoWrapper))
                return;
            if(!this.isElementPartiallyInViewport($this))
                return;
            var top = 0;
            var boundingRect = this.getBoundingClientRect($this);
            var td = (boundingRect.top <= 0) ? -1 * boundingRect.top : 0;
            var bu = (boundingRect.bottom >= $(window).height()) ? (boundingRect.bottom - $(window).height()) : 0;
            top = td + (0.5 * ( $this.height() - td - bu ));
            logoWrapper.css("top",`${top}px`);
        }
    };

    window.pixelpoint.ppComponents.loader = function ($this) {
        //var $this = $(this);

        if ($this.hasClass("loader-initialized"))
            return;

        var name = $this.data("name");
        if (!name) {
            name = `loader-${counter}`;
            $this.attr("data-name", name).data("name", name);
            counter++;
        }
        var id = $this.attr("id");
        if (!id) {
            id = name;
            $this.attr("id", id);
        }

        /*
        $this.html(`<div class="loader-image-wrapper"><i class="icon-logo"></i></div>`);
        $this.on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',function(e) {
            $this.parent().removeClass("animation-show").removeClass("animation-hide");
        });
        //*/
        var tmbLoaderSrc = getComputedStyle(document.documentElement).getPropertyValue("--tmb-loader-path").trim().replace(/^["']|["']$/g, "");
        $this.html(`<div class="loader-image-wrapper"><img alt="Brandenburg Loader" src="${tmbLoaderSrc}" /></div>`);

        $this.addClass("hidden");
        var exposed = {
            show() {
                $this.removeClass("hidden");
                $this.parent().addClass("loader-shown");
                privateFunctions.positionLogo($this); 
                $(document).on("scroll.loader",() => {
                    privateFunctions.positionLogo($this); 
                });
                $(window).on("orientationchange.loader", function () {
                    privateFunctions.positionLogo($this);
                });
                $this.parent().addClass("animation-show");
            },
            hide() {
                $this.addClass("hidden");
                $this.parent().removeClass("loader-shown");
                $this.parent().addClass("animation-hide");
                $(document).off("scroll.loader",() => {
                    privateFunctions.positionLogo($this); 
                });
                $(window).off("orientationchange.loader", function () {
                    privateFunctions.positionLogo($this);
                });
            }
        };
        $this.data("exposed", exposed);
        window.pixelpoint.pubSub.subscribe(window.pixelpoint.pubSub.events.loader + `:${name}:show`, exposed.show);
        window.pixelpoint.pubSub.subscribe(window.pixelpoint.pubSub.events.loader + `:${name}:hide`, exposed.hide);

        $this.addClass("loader-initialized");
    }

    $(".loader[data-loader]").each(function () {
        window.pixelpoint.ppComponents.loader($(this));
    });

});